import React, { Component } from 'react';
import {Header, Icon, Container, Grid, Tab, TextArea, Form, Menu, Dropdown, Label, Divider} from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import GeneratedLicenseWizard  from './GeneratedLicenses/GeneratedLicenseWizard'
import GeneratedLicenseList from './GeneratedLicenses/GeneratedLicenseList'

import LicenseAccessManagement from "../containers/LicenseAccess/LicenseAccessManagement";
import GeneratedLicenseManagement from "../containers/GeneratedLicenses/GeneratedLicenseManagement";
import UserManagement from "../containers/Users/UserManagement";
import MachineReport from "../containers/MachineReport/MachineReport";
import LicenseChecker from "../containers/LicenseChecker/LicenseChecker";
// import GeneratedLicenseManagement from "./GeneratedLicenses/GeneratedLicenseManagement";

/*
const panes = [
    { menuItem: 'Register new license' , render: () => <Tab.Pane attached={false}><GeneratedLicenseWizard /> </Tab.Pane>},
    { menuItem: 'View registered licenses' , render: () => <Tab.Pane attached={false}><GeneratedLicenseList/></Tab.Pane>},
    { menuItem: 'View registered users' , render: () => <Tab.Pane attached={false}><GeneratedLicenseList/></Tab.Pane>},
]
*/


export default class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = { activeItem: 'listLicenses', isUserManagement: false, admin_info: 0}
    }

    componentWillMount() {
        if (!this.props.isLoggedIn) this.props.history.push('/login')
    }
    componentDidMount() {
        // Restore product codes and admin flag after a refresh (they live only
        // in redux state, which is rebuilt empty on reload).
        if (this.props.isLoggedIn) this.props.loadSession()
    }
    componentWillReceiveProps() {
        if (!this.props.isLoggedIn) this.props.history.push('/login')
    }

    getCategory(name) {
        var categories = ['listLicenseAccess', 'listUsers', 'addUser', 'removeUser'];
        return categories.includes(name);
    }
    handleItemClick = (e, { name }) => this.setState({
        activeItem: name,
        isUserManagement: this.getCategory(name)
    })



    render() {
        const {activeItem, isUserManagement} = this.state;

        const access_level = !this.props.isAdmin ? 'Regular user' : 'Admin';
        return (
            <React.Fragment>
                <Menu>
                    <Menu.Item header>
                        <Icon name='key'/>
                        Kelda License Management
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Icon name='settings'/>
                        </Menu.Item>
                        <Dropdown item text={`${this.props.userName} (${access_level})`}>
                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    <Link to='/logout'>{`logout`}</Link>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Menu>
                </Menu>
                        <Menu vertical floated>
                            <Menu.Item>
                                <Menu.Header name='Users'>
                                    <Icon name='user'/>
                                    Registered users
                                </Menu.Header>
                                <Menu.Menu >
                                    <Menu.Item name='listUsers' active={activeItem === 'listUsers'} onClick={this.handleItemClick}>
                                        Registered users
                                    </Menu.Item>
                                </Menu.Menu>

                            </Menu.Item>
                            <Menu.Item>
                                <Menu.Header name='Licenses'>
                                    <Icon name='key'/>
                                    Licenses
                                </Menu.Header>

                                <Menu.Menu>
                                    <Menu.Item name='listLicenseAccess' active={activeItem === 'listLicenseAccess'} onClick={this.handleItemClick}>
                                        User licenses
                                    </Menu.Item>
                            {/*        <Menu.Item name='addUser' active={activeItem === 'addUser'} onClick={this.handleItemClick}>
                                        Add LicenseAccess
                                    </Menu.Item>
                                    <Menu.Item name='removeUser' active={activeItem === 'removeUser'} onClick={this.handleItemClick}>
                                        Remove LicenseAccess
                                    </Menu.Item>*/}
                                </Menu.Menu>
                            </Menu.Item>
                             <Menu.Item>
                                 <Menu.Header name='Licenses'>
                                    <Icon name='user secret'/>
                                     Computer installations
                                 </Menu.Header>
                                 <Menu.Menu>
                                     <Menu.Item name='listLicenses' active={activeItem === 'listLicenses'} onClick={this.handleItemClick}>
                                         Offline licence registrations
                                     </Menu.Item>
 {/*                                    <Menu.Item name='registerLicense' active={activeItem === 'registerLicense'} onClick={this.handleItemClick}>
                                         Register GeneratedLicenses
                                     </Menu.Item>
 */}                                </Menu.Menu>
                             </Menu.Item>
                             <Menu.Item>
                                 <Menu.Header name='Reports'>
                                    <Icon name='desktop'/>
                                     Reports
                                 </Menu.Header>
                                 <Menu.Menu>
                                     <Menu.Item name='listMachines' active={activeItem === 'listMachines'} onClick={this.handleItemClick}>
                                         Licenses per machine
                                     </Menu.Item>
                                     <Menu.Item name='licenseChecker' active={activeItem === 'licenseChecker'} onClick={this.handleItemClick}>
                                         License checker
                                     </Menu.Item>
                                 </Menu.Menu>
                             </Menu.Item>
                           {/* <Menu.Item>
                                <Menu.Header name='Enterprise'>
                                    <Icon name='settings'/>
                                    Enterprise Management
                                </Menu.Header>
                            </Menu.Item>*/}
                        </Menu>
                    <Grid >
                    <Grid.Row >

                        <Grid.Column width={16} floated='right'>
                            {{
                                listLicenses: (<GeneratedLicenseManagement type={activeItem}/>),
                                listLicenseAccess: (<LicenseAccessManagement type={activeItem}/>),
                                listUsers: (<UserManagement/>),
                                listMachines: (<MachineReport/>),
                                licenseChecker: (<LicenseChecker/>)
                            }[activeItem]}

                        </Grid.Column>

                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }
};
